import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { apiUrl } from "../../lib/config";

export function LoginPage() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ssoState = searchParams.get("sso");

  useEffect(() => {
    // If already authenticated, go straight to admin.
    if (isAuthenticated) {
      navigate("/admin", { replace: true });
      return;
    }
    // If there's an SSO error state, don't loop — stay and show the message.
    if (ssoState === "error" || ssoState === "pending") return;

    // Fetch auth config from backend to determine login flow.
    fetch(apiUrl("/api/v1/auth/config/"))
      .then((res) => (res.ok ? res.json() : { enable_iam: false }))
      .then((config) => {
        const next = encodeURIComponent("/admin");
        if (config.enable_iam) {
          // Aptean IAM (Keycloak) — silent SSO for users already logged in to AppCentral.
          window.location.href = apiUrl(`/api/v1/auth/iam/login/?next=${next}`);
        } else {
          // Microsoft Entra ID (SSO) via OAUTH_* configuration.
          window.location.href = apiUrl("/api/v1/admin/auth/sso/login/");
        }
      })
      .catch(() => {
        // Fallback to IAM on network failure.
        const next = encodeURIComponent("/admin");
        window.location.href = apiUrl(`/api/v1/auth/iam/login/?next=${next}`);
      });
  }, [isAuthenticated, navigate, ssoState]);

  // Only shown on SSO error/pending — normal users never see this.
  return (
    <main className="aptean-page aptean-login-page">
      <div className="aptean-login-page__card">
        <h1 className="aptean-login-page__title">Aptean StatusCentral</h1>
        <p className="aptean-login-page__subtitle">Admin portal</p>

        {ssoState === "pending" && (
          <p role="alert" className="aptean-login-page__alert aptean-login-page__alert--warning">
            Access pending approval. Contact your administrator.
          </p>
        )}
        {ssoState === "error" && (
          <p role="alert" className="aptean-login-page__alert aptean-login-page__alert--error">
            You&apos;re not authorized to access this page. Please contact the Aptean Platform Engineering Team.
          </p>
        )}

        <div className="aptean-login-page__logo">
          <img
            src="https://stshrnextgenstorage.blob.core.windows.net/aptean-theme/Aptean-logo-login.png"
            alt="Aptean"
          />
        </div>
      </div>
    </main>
  );
}
